export default function Header() {
    return (
        <>
            <a href="https://rocketpool.net/#header" className="hidden" id="#header">Header</a>
            <a
                href="https://rocketpool.net/#stake-run-node"
                className="hidden"
                id="#stake-run-node"
            >stake-run-node</a>
            <a
                href="https://rocketpool.net/#security"
                className="hidden"
                id="#security"
            >Security</a>
            <a
                href="https://rocketpool.net/#how-it-works"
                className="hidden"
                id="#how-it-works"
            >How it works</a>
            <a
                href="https://rocketpool.net/#community"
                className="hidden"
                id="#community"
            >Community</a>
            <a href="https://rocketpool.net/#news" className="hidden" id="#news"
            >News</a>
            <a href="https://rocketpool.net/#team" className="hidden" id="#team"
            >Team</a>
            <a href="https://rocketpool.net/#dao" className="hidden" id="#dao">Dao</a>
            <a
                href="https://rocketpool.net/#node-operator-interest"
                className="hidden"
                id="#node-operator-interest"
            >Node Operator Interest</a>
            <a href="https://rocketpool.net/#footer" className="hidden" id="#footer"
            >Footer
            </a>
        </>
    );
}
